import {
  ServerThemeType,
  parseLegacyDtcThemeResponse,
} from "@brandclub/common-ui";
import { BrandAppConfig, WebAndBrandAppConfig } from "../../../redux/types";
import axios from "../../../utils/axios";
import { LegacyTheme } from "@brandclub/common-ui";

type GetAppThemeDraftResponse =
  | {
      brandAppTheme: ServerThemeType;
      configId: string;
      draftId: string;
      status: "success";
    }
  | {
      status: "failed";
      errorMessage: string;
    }
  | {
      status: "notFound";
      errorMessage: string;
    };

interface AppSetupTheme {
  colorOptions: string[];
  fontOptions: string[];
  theme: ServerThemeType | LegacyTheme;
  draftId: string | undefined;
}

interface UpdateAppSetupThemeRequest extends AppSetupTheme {
  appId: string;
  setupId: string;
}

type GetAppSetupThemeResponse =
  | (AppSetupTheme & {
      status: "success";
    })
  | {
      status: "failed";
      errorMessage: string;
    }
  | {
      status: "notFound";
      errorMessage: string;
    };

export const getBrandAppConfig = async (req: { appId: string }) => {
  const res = await axios.post<BrandAppConfig>(
    "/brandapp/getBrandAppConfig",
    req
  );
  return res?.data;
};

export const getCustomTheme = async () => {
  const appId = window.location.origin.split("https://")[1];
  const { data } = await axios.post<ServerThemeType>(
    "/brandapp/getDTCAppTheme",
    {
      appId: appId,
      themeAppId: appId,
    }
  );

  return parseLegacyDtcThemeResponse(data, true);
};

export const getAppThemeDraft = async (
  appId: string,
  appThemeId: string
): Promise<GetAppThemeDraftResponse> => {
  const res = await axios.post("/brandapp/getAppThemeDraft", {
    appId,
    appThemeId,
  });
  const brandAppTheme =
    res.data?.brandAppTheme &&
    parseLegacyDtcThemeResponse(res.data.brandAppTheme, true);
  if (!brandAppTheme) {
    console.error(res.statusText);
    throw new Error("Error fetching app theme draft");
  }
  return {
    ...res.data,
    brandAppTheme,
  };
};

export const getAppSetupTheme = async (
  appId: string,
  setupId: string
): Promise<GetAppSetupThemeResponse> => {
  const res = await axios.get("/brandapp/themeSetup", {
    params: { appId, setupId },
  });
  return res.data;
};

export const updateAppSetupTheme = async (
  req: UpdateAppSetupThemeRequest
): Promise<GetAppSetupThemeResponse> => {
  const res = await axios.post("/brandapp/themeSetup", req);
  return res.data;
};

export interface GetAppConfigFromServerResponse {
  appConfig: WebAndBrandAppConfig | undefined;
}
export const getAppConfigFromServer =
  async (): Promise<GetAppConfigFromServerResponse> => {
    const { data } = await axios.get(`/config/webApp/getAppConfig`, {});

    if (data) {
      return {
        appConfig: {
          authConfig: data.authConfig,
          domainConfig: data.domainConfig,
        },
      };
    }

    return {
      appConfig: undefined,
    };
  };
